import { render, staticRenderFns } from "./my-img.vue?vue&type=template&id=6b76eff0&scoped=true&"
import script from "./my-img.vue?vue&type=script&lang=js&"
export * from "./my-img.vue?vue&type=script&lang=js&"
import style0 from "./my-img.vue?vue&type=style&index=0&id=6b76eff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76eff0",
  null
  
)

export default component.exports